<div class="container my-3 p-3 General container-fluid" style="position: relative;">
  <h3>{{'AssessmentRoll.SearchTitle' | translate}}</h3>
  @for (item of items; track item) {
    <div class="list-group">
      <app-pdf-url-row>
        <a href="{{item.fileUrl}}" target="_blank">
          <div class="col-10 d-flex align-items-center p-0">
            <div style="">
              <h1 >{{item.year}}</h1>
            </div>
            <div class="p-3">
              @if (item.id == 19) {
                <p><strong>{{'Assessment Roll' | translate}}</strong> <br> <span>{{item.reportDate}}</span></p>
              }
              @if (item.id != 19) {
                <p><strong>{{'AssessmentRoll.RollForecast' | translate}}</strong> <br> <span>{{item.reportDate}}</span></p>
              }
            </div>
          </div>
        </a>
      </app-pdf-url-row>
    </div>
  }
</div>
